/**
 * @fileoverview Agent definition for style-analyzer-v2.
 *
 * This agent analyzes writing samples and influences to determine
 * their stylistic properties on a 0-4 scale across 14 dimensions,
 * including narrative distance, pacing, dialogue texture, and more.
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'style-analyzer-v2',
  kind: 'primitive',
  name: 'Style Analyzer',
  description: 'Analyzes writing samples and influences to determine their stylistic properties on a 10-point scale.',
  category: 'style',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Improvement #4 + Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-08',
    lastUpdated: '2025-01',
    usedBy: [
      'StyleGuideComposer',
      'use-style-guide-analyzer.ts',
    ],
    usedInComposites: ['extract-styleguide-v2'],
    relatedAgents: [
      'generate-custom-style-guide-v2',
      'genre-detector-v2',
    ],
    taxonomyPath: 'meta.style.analysis',
  },
};
